export interface SponsorItem {
  icon: string;
  label: string; // This should now be a translation key, not plain text
  value: string;
}

export const sponsorData: SponsorItem[] = [
  { icon: '/images/IKI.png', label: '', value: '' },
  { icon: '/images/gizlogo.png', label: '', value: '' },
  { icon: '/images/akdn.png', label: '', value: '' },
  { icon: '/images/mfsyslogo.png', label: '', value: '' },
];

export {};
